import type { SxProps, Theme } from '@mui/material/styles';

/** Style dùng chung cho mọi nơi render markdown (preview nội bộ + trang chia sẻ công khai). */
export const markdownPreviewSx: SxProps<Theme> = {
  '& > :first-of-type': { mt: 0 },
  '& > :last-child': { mb: 0 },
  '& h1, & h2, & h3, & h4, & h5, & h6': { mt: 2.5, mb: 1 },
  '& p': { my: 1.25, lineHeight: 1.6 },
  '& ul, & ol': { my: 1, pl: 3 },
  '& blockquote': {
    my: 1.5,
    pl: 2,
    borderLeft: '3px solid',
    borderColor: 'divider',
    color: 'text.secondary',
  },
  '& code': {
    fontFamily: 'monospace',
    bgcolor: 'action.hover',
    px: 0.5,
    borderRadius: 0.5,
  },
  '& pre': {
    bgcolor: 'action.hover',
    p: 1.5,
    borderRadius: 1,
    overflow: 'auto',
  },
  '& pre code': { bgcolor: 'transparent', px: 0 },
  '& table': { borderCollapse: 'collapse', my: 1.5 },
  '& th, & td': {
    border: '1px solid',
    borderColor: 'divider',
    px: 1,
    py: 0.5,
  },
  '& img': { maxWidth: '100%' },
  '& a': { color: 'primary.main' },
};
